import { useEffect } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import "../styles/QRScanner.css";
import XIcon from "../icons/XIcon";
export default function QRScanner({ onScanSuccess, onClose }) {
  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      "reader",
      {
        fps: 10,
        qrbox: {
          width: 250,
          height: 250,
        },
        rememberLastUsedCamera: true,
      },
      false,
    );

    scanner.render(
      (decodedText) => {
        onScanSuccess(decodedText);

        scanner.clear().catch(() => {});
      },
      () => {},
    );

    return () => {
      scanner.clear().catch(() => {});
    };
  }, [onScanSuccess]);

  return (
    <div className="scanner-overlay">
      <div className="scanner-modal">
        <div className="scanner-header">
          <div className="scanner-close-button" onClick={onClose}>
            <XIcon />
          </div>
        </div>

        <div id="reader" />
      </div>
    </div>
  );
}
